import script from "./MessageAttachmentsGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageAttachmentsGallery.vue?vue&type=script&setup=true&lang=js"

import "./MessageAttachmentsGallery.vue?vue&type=style&index=0&id=207827ac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-207827ac"]])

export default __exports__